import z from "zod";

export const patchVehicleAssignmentPlanSchema = z.object({
	assignmentId: z.uuid(),
});

export const patchVehicleAssignmentPlanJsonSchema = z.object({
	userId: z.string().nullable(),
});

export type PatchVehicleAssignmentPlanSchema = z.infer<typeof patchVehicleAssignmentPlanSchema>;
